<template>
    <div class="contact-form">
        <itsu-errors
            v-if="states.errors.length"
            :errors="states.errors"
        />

        <form
            @submit.prevent="handleSubmit"
            v-test:form
        >
            <fieldset
                :disabled="states.loading"
                v-test:fieldset
            >
                <atreemo-survey
                    :questions="questions"
                    v-model="formData"
                />

                <transition name="fade-in-up">
                    <div
                        v-if="canSubmit"
                        class="submit-button"
                    >
                        <b-button
                            variant="primary"
                            type="submit"
                            v-test:submitButton
                        >
                            {{ submitButtonText }}
                        </b-button>
                    </div>
                </transition>
            </fieldset>
        </form>
    </div>
</template>

<script>
    import AtreemoSurvey from '../AtreemoSurvey/AtreemoSurvey';
    import { mapActions } from 'vuex';
    import ItsuErrors from '../ItsuErrors/ItsuErrors';

    export default {
        name: 'contact-form',

        components: { ItsuErrors, AtreemoSurvey },

        props: {
            opCode: {
                type: [String, Number],
                required: true,
            },

            questions: {
                type: Array,
                default: () => ([]),
            },

            submitButtonText: {
                type: String,
                required: true,
            },
        },

        data() {
            return {
                formData: this.questions
                    .reduce((formData, { id }) => ({
                        ...formData,
                        [id]: null,
                    }), {}),
                states: {
                    loading: false,
                    errors: [],
                },
            };
        },

        computed: {
            /**
             * Check if the form can be submitted.
             *
             * @returns {boolean}
             */
            canSubmit() {
                return Object.entries(this.formData)
                    .some(([, val]) => ![null, undefined].includes(val));
            },
        },

        methods: {
            ...mapActions('atreemo', [
                'submitSurvey',
            ]),

            /**
             * Handle the form submission.
             */
            async handleSubmit() {
                if (!this.canSubmit) {
                    return;
                }

                this.states.errors = [];
                this.states.loading = true;

                try {
                    const formData = new FormData;

                    Object.entries(this.formData)
                        .filter(([, value]) => value !== null)
                        .map(([id, value]) => ({
                            id,
                            value,
                        })).forEach(({ id, value }) => {
                            formData.append(`answers[${ id }]`, value);
                        });

                    await this.submitSurvey({
                        id: this.opCode,
                        formData,
                    });

                    this.$emit('success');
                } catch ({ response }) {
                    this.states.errors = response
                        ?.data
                        ?.error
                        ?.details
                        ?.errors
                        || [
                            this.$snippet('submit_error_fallback', 'There was an issue submitting your responses'),
                        ];
                } finally {
                    this.states.loading = false;
                }
            },
        },
    };
</script>

<style lang="scss" scoped>
    .fade-in-up-enter-active,
    .fade-in-up-leave-active {
        transition: 0.5s;
    }

    .fade-in-up-enter,
    .fade-in-up-leave-to {
        opacity: 0;
        transform: translateY(5px);
    }

    .submit-button {
        margin-top: 30px;
        text-align: center;
    }

    .btn {
        min-width: 140px;
    }
</style>
